/** Anzahl fester Schnellverkauf-Kacheln pro Seite (muss mit api/core/pos_settings.MAX_POS_TILES übereinstimmen). */
export const MAX_POS_TILES = 12;

/** Maximale Anzahl Kachel-Seiten (muss mit api/core/pos_settings.MAX_POS_TILE_PAGES übereinstimmen). */
export const MAX_POS_TILE_PAGES = 10;

export interface PosTilePage {
  label: string;
  tile_article_ids: (string | null)[];
}

export function emptyTilePage(): PosTilePage {
  return {
    label: "",
    tile_article_ids: Array.from({ length: MAX_POS_TILES }, () => null),
  };
}

export function pageDisplayLabel(label: string, index: number): string {
  const trimmed = label.trim();
  return trimmed || `Seite ${index + 1}`;
}

export function normalizeTilePages(raw: PosTilePage[] | undefined | null): PosTilePage[] {
  if (!raw?.length) {
    return [emptyTilePage()];
  }
  return raw.slice(0, MAX_POS_TILE_PAGES).map((page) => ({
    label: page.label ?? "",
    tile_article_ids: Array.from(
      { length: MAX_POS_TILES },
      (_, i) => page.tile_article_ids[i] ?? null,
    ),
  }));
}

/** Alte API-Antwort mit nur tile_article_ids in eine Seite umwandeln. */
export function tilePagesFromLegacyIds(ids: (string | null)[] | undefined): PosTilePage[] {
  return [
    {
      label: "",
      tile_article_ids: Array.from({ length: MAX_POS_TILES }, (_, i) => ids?.[i] ?? null),
    },
  ];
}
